import {
  StartWidgetWrapper,
  UnitInput,
  RadioGroup,
  Checkbox,
  Inputs,
  CheckboxGroup,
} from '@kizi/comparator-components';

import {
  Anchor as CoreAchor,
  Button,
  Div,
  Heading,
  Image,
  Input,
  Label,
  List,
  ListItem,
  P,
  Select as CoreSelect,
  Span,
  Svg,
} from '@kizi/core-components';
import {
  CommentWithAvatar,
  CommentWithAvatarWrapper,
} from './CommentWithAvatar';
import { ContentTypeCheckbox } from './wrappers/Checkbox/contentTypeCheckbox';
import { SpecificChannelSearch } from './Inputs/SpecificChannelSearch';
import { ProductSummaryWrapper } from './wrappers/ProductSummaryWrapper';
import { HowItWorksWrapper } from './wrappers/HowItWorksWrapper';
import { ExtraOptionsCheckbox } from './Inputs/ExtraOptionsCheckbox';
import { ExtraOptionsRadio } from './Inputs/ExtraOptionsRadio';
import { ExtraOptionsSelect } from './Inputs/ExtraOptionsSelect';
import { RetentionDisclaimer } from './RetentionDisclaimer';
import { ProductCardTriplePlayTopThree } from './ProductCardTriplePlay/ProductCardTriplePlayTopThree';

import { CombinationDiscount } from './CombinationDiscount';
import { SpeedPopup } from './SpeedPopup';
import { CheckoutPage } from './Pages/CheckoutPage';
import { CustomerBenefit } from './CustomerBenefit';
export * from './TextWithLink';
import { ProductCardTriplePlay } from './ProductCardTriplePlay/ProductCardTriplePlay';

// Empty components to make sure the apply page doesn't break, to be created!
const Info = () => null;
const AddressBirthdateDisplay = () => null;
const AfterTheSwitchWrapper = () => null;

// Exports
export * from './Pages';
export * from '../utils/filterQuery';
export * from '@kizi/comparator-components';
export * from '@kizi/shared-components';

export {
  CoreAchor,
  Button,
  Div,
  Heading,
  Image,
  Input,
  Label,
  List,
  ListItem,
  P,
  CoreSelect,
  Span,
  Svg,
  UnitInput,
  RadioGroup,
  Checkbox,
  CommentWithAvatar,
  CommentWithAvatarWrapper,
  StartWidgetWrapper,
  Inputs,
  Info,
  AddressBirthdateDisplay,
  AfterTheSwitchWrapper,
  ContentTypeCheckbox,
  CheckboxGroup,
  CombinationDiscount,
  ProductSummaryWrapper,
  HowItWorksWrapper,
  SpeedPopup,
  SpecificChannelSearch,
  ExtraOptionsCheckbox,
  ExtraOptionsRadio,
  ExtraOptionsSelect,
  CheckoutPage,
  RetentionDisclaimer,
  CustomerBenefit,
  ProductCardTriplePlay,
  ProductCardTriplePlayTopThree,
};
